export default "__VITE_ASSET__db3b63e2__"